// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"c32c0942","55":"e3b9b2c8","187":"7ec147f4","191":"ba42cd3e","227":"7fb3baf1","457":"7c1788ec","496":"3da47f5d","574":"e66d17e3","576":"565a1d39","780":"e81ddf0b","938":"e4f39794"}[chunkId] + ".chunk.js";
};